export const EventTypes = {
  EVENT_TYPE_ERC20_TRANSFER: 'EVENT_TYPE_ERC20_TRANSFER',
  EVENT_TYPE_ERC721_TRANSFER: 'EVENT_TYPE_ERC721_TRANSFER',
  EVENT_TYPE_WALLET_ACTIVITY: 'EVENT_TYPE_WALLET_ACTIVITY',
  EVENT_TYPE_SMART_CONTRACT_ACTIVITY: 'EVENT_TYPE_SMART_CONTRACT_ACTIVITY',
};

export const SUPPORTED_EVENT_TYPES = Object.values(EventTypes);

export const WEBHOOK_STATUS = {
  active: 'WEBHOOK_STATUS_ACTIVE',
  deactivated: 'WEBHOOK_STATUS_DEACTIVATED',
};
